import { Content, ContentTable, TableCell, TDocumentDefinitions } from "pdfmake/interfaces";

import schemaJson from './finalthesis.schema.json';
import * as Form from './finalthesis';
import * as Data from './DataRepresentation';
import { FORM_DATE, FORM_NAME, FORM_VERSION } from "./DataRepresentation";

import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import {fillIn} from "./I18n";
import {JsonSchema7} from "@jsonforms/core";
import {TFnType} from "@tolgee/react";

// @ts-expect-error: addVirtualFileSystem is not defined
pdfMake.addVirtualFileSystem(pdfFonts)

const UNI_MR = '<svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"  width="1834.5699px" height="659px" viewBox="0 0 1834.5699 659"><namedview pagecolor="#ffffff" bordercolor="#000000" borderopacity="0.25"/><g transform="matrix(8.7357269,0,0,8.7357269,-4325.2095,-3820.9768)"><path d="m 142.482,73.2192 c 0,1.1348 -0.249,2.1571 -0.747,3.068 -0.496,0.9109 -1.248,1.6303 -2.25,2.1591 -1.004,0.5299 -2.272,0.7933 -3.803,0.7933 -2.174,0 -3.829,-0.5559 -4.962,-1.6657 -1.134,-1.1108 -1.701,-2.5766 -1.701,-4.3994 V 62.6058 h 3.47 v 10.0398 c 0,1.3482 0.275,2.2976 0.827,2.8494 0.55,0.5507 1.37,0.8255 2.457,0.8255 1.134,0 1.959,-0.2967 2.471,-0.8953 0.512,-0.5965 0.77,-1.5314 0.77,-2.8025 V 62.6058 h 3.468 z m 10.868,-6.983 c -0.782,0 -1.521,0.1457 -2.218,0.4351 -0.697,0.2925 -1.244,0.76 -1.643,1.4023 h -0.183 l -0.459,-1.6074 h -2.619 v 12.5435 h 3.423 v -5.9048 c 0,-1.3325 0.192,-2.3558 0.574,-3.0658 0.382,-0.7121 1.095,-1.0692 2.136,-1.0692 0.705,0 1.218,0.2259 1.541,0.6788 0.322,0.4497 0.482,1.1285 0.482,2.0321 v 7.3289 h 3.423 v -8.1794 c 0,-1.6084 -0.407,-2.7754 -1.219,-3.5021 -0.812,-0.7277 -1.889,-1.092 -3.238,-1.092 m 9.693,-4.6868 c -0.521,0 -0.96,0.1197 -1.32,0.3571 -0.36,0.2373 -0.54,0.6767 -0.54,1.32 0,0.6278 0.18,1.065 0.54,1.3107 0.36,0.2446 0.799,0.3664 1.32,0.3664 0.505,0 0.943,-0.1218 1.309,-0.3664 0.369,-0.2457 0.552,-0.6829 0.552,-1.3107 0,-0.6433 -0.183,-1.0827 -0.552,-1.32 -0.366,-0.2374 -0.804,-0.3571 -1.309,-0.3571 m 1.7,4.9168 h -3.422 v 12.5435 h 3.422 z m 10.087,12.5432 4.779,-12.5435 h -3.585 l -2.412,7.1436 c -0.291,0.8901 -0.46,1.7469 -0.506,2.5745 h -0.092 c -0.015,-0.3675 -0.064,-0.7808 -0.149,-1.2409 -0.085,-0.4601 -0.195,-0.9036 -0.333,-1.3336 l -2.413,-7.1436 h -3.583 l 4.779,12.5435 z m 11.74,-12.7729 c -1.181,0 -2.214,0.2446 -3.102,0.7349 -0.888,0.4893 -1.582,1.2202 -2.079,2.1946 -0.498,0.9723 -0.746,2.1934 -0.746,3.6644 0,1.4398 0.275,2.6338 0.826,3.5822 0.552,0.9495 1.311,1.6584 2.276,2.1258 0.965,0.4675 2.075,0.7007 3.331,0.7007 0.965,0 1.787,-0.0729 2.47,-0.2187 0.68,-0.1457 1.328,-0.3695 1.941,-0.6766 v -2.6422 c -0.705,0.3373 -1.388,0.5861 -2.046,0.7464 -0.658,0.1604 -1.393,0.2416 -2.204,0.2416 -0.965,0 -1.72,-0.277 -2.264,-0.8266 -0.544,-0.5518 -0.83,-1.3107 -0.862,-2.2757 h 8.088 V 71.933 c 0,-1.8207 -0.507,-3.2272 -1.516,-4.2162 -1.012,-0.9869 -2.382,-1.4803 -4.113,-1.4803 m 0.024,2.4339 c 0.811,0 1.407,0.2509 1.792,0.7475 0.383,0.4976 0.58,1.1295 0.597,1.8957 h -4.803 c 0.077,-0.9046 0.333,-1.5699 0.77,-1.9998 0.436,-0.4279 0.984,-0.6434 1.644,-0.6434 m 15.391,-2.4342 c -0.842,0 -1.586,0.23 -2.229,0.6902 -0.644,0.458 -1.147,1.0087 -1.516,1.6521 h -0.161 l -0.505,-2.1123 h -2.597 v 12.5435 h 3.423 v -6.3868 c 0,-0.7964 0.165,-1.4251 0.496,-1.8842 0.329,-0.4581 0.761,-0.7933 1.298,-0.9984 0.534,-0.2082 1.093,-0.3113 1.676,-0.3113 0.154,0 0.333,0.0115 0.54,0.0344 0.207,0.0239 0.364,0.05 0.472,0.0801 l 0.252,-3.2157 c -0.137,-0.0302 -0.321,-0.0542 -0.551,-0.0687 -0.23,-0.0157 -0.43,-0.0229 -0.598,-0.0229 m 12.177,9.0509 c 0,-0.7496 -0.142,-1.3596 -0.425,-1.8271 -0.284,-0.4653 -0.686,-0.8557 -1.206,-1.1701 -0.521,-0.3144 -1.142,-0.6173 -1.862,-0.9088 -0.735,-0.304 -1.29,-0.5507 -1.664,-0.734 -0.375,-0.1832 -0.628,-0.356 -0.759,-0.5163 -0.131,-0.1614 -0.194,-0.3425 -0.194,-0.5403 0,-0.5518 0.505,-0.8266 1.516,-0.8266 0.567,0 1.126,0.0875 1.677,0.2634 0.551,0.1759 1.133,0.3945 1.747,0.6548 l 1.031,-2.4589 c -0.749,-0.3509 -1.477,-0.6038 -2.182,-0.7569 -0.705,-0.153 -1.447,-0.23 -2.228,-0.23 -1.502,0 -2.703,0.2915 -3.607,0.8734 -0.904,0.5809 -1.355,1.4543 -1.355,2.6193 0,0.7047 0.122,1.2898 0.368,1.7572 0.245,0.4675 0.619,0.8651 1.126,1.1941 0.505,0.33 1.148,0.6621 1.929,0.9994 0.812,0.3363 1.408,0.6132 1.791,0.8276 0.383,0.2134 0.632,0.406 0.748,0.5736 0.114,0.1687 0.173,0.3592 0.173,0.5747 0,0.3217 -0.143,0.5809 -0.425,0.7808 -0.284,0.1988 -0.763,0.2977 -1.436,0.2977 -0.598,0 -1.289,-0.0989 -2.068,-0.2977 -0.781,-0.1999 -1.509,-0.4518 -2.183,-0.7589 v 2.8274 c 0.627,0.2592 1.256,0.4466 1.884,0.5622 0.628,0.1145 1.378,0.1728 2.251,0.1728 1.776,0 3.112,-0.3404 4.009,-1.0233 0.897,-0.6809 1.344,-1.6584 1.344,-2.9295 m 4.388,-13.7377 c -0.522,0 -0.961,0.1197 -1.32,0.3571 -0.362,0.2373 -0.541,0.6767 -0.541,1.32 0,0.6278 0.179,1.065 0.541,1.3107 0.359,0.2446 0.798,0.3664 1.32,0.3664 0.505,0 0.942,-0.1218 1.308,-0.3664 0.369,-0.2457 0.552,-0.6829 0.552,-1.3107 0,-0.6433 -0.183,-1.0827 -0.552,-1.32 -0.366,-0.2374 -0.803,-0.3571 -1.308,-0.3571 m 1.699,4.9168 h -3.423 v 12.5435 h 3.423 z m 8.869,10.0398 c -0.444,0 -0.803,-0.1197 -1.08,-0.3571 -0.275,-0.2373 -0.414,-0.5923 -0.414,-1.067 v -6.0433 h 3.515 v -2.5724 h -3.515 v -2.6661 h -2.182 l -0.989,2.6422 -1.882,1.1493 v 1.447 h 1.63 v 6.0433 c 0,1.0712 0.172,1.9103 0.518,2.5141 0.344,0.6059 0.812,1.0306 1.4,1.2753 0.589,0.2446 1.261,0.3685 2.01,0.3685 0.644,0 1.238,-0.0583 1.782,-0.1728 0.542,-0.1156 0.998,-0.2478 1.366,-0.4019 v -2.5495 c -0.353,0.1062 -0.704,0.1978 -1.055,0.2749 -0.354,0.076 -0.723,0.1155 -1.104,0.1155 m 9.833,-10.2926 c -0.888,0 -1.743,0.0999 -2.562,0.2977 -0.818,0.1999 -1.567,0.4747 -2.239,0.8276 l 1.125,2.3205 c 0.581,-0.2592 1.163,-0.4789 1.746,-0.6538 0.582,-0.178 1.179,-0.2654 1.791,-0.2654 0.614,0 1.093,0.153 1.436,0.4591 0.346,0.3071 0.517,0.7891 0.517,1.447 v 0.5518 l -2.183,0.0697 c -1.867,0.0614 -3.27,0.4091 -4.202,1.0452 -0.935,0.635 -1.403,1.6188 -1.403,2.9514 0,1.3481 0.368,2.3485 1.103,2.9992 0.735,0.6506 1.662,0.9765 2.781,0.9765 1.041,0 1.86,-0.1541 2.457,-0.4601 0.597,-0.3072 1.164,-0.7964 1.7,-1.47 h 0.092 l 0.665,1.7 h 2.389 v -8.3637 c 0,-1.5012 -0.446,-2.6151 -1.341,-3.3428 -0.898,-0.7266 -2.188,-1.0899 -3.872,-1.0899 m -3.859,-2.9649 c 0,0.507 0.151,0.8828 0.458,1.1274 0.306,0.2447 0.674,0.3665 1.102,0.3665 0.429,0 0.801,-0.1218 1.115,-0.3665 0.315,-0.2446 0.471,-0.6204 0.471,-1.1274 0,-0.5351 -0.156,-0.9213 -0.471,-1.1587 -0.314,-0.2384 -0.686,-0.3571 -1.115,-0.3571 -0.428,0 -0.796,0.1187 -1.102,0.3571 -0.307,0.2374 -0.458,0.6236 -0.458,1.1587 m 5.673,9.9481 v 1.0338 c 0,0.7964 -0.251,1.4137 -0.758,1.8489 -0.505,0.4383 -1.126,0.6548 -1.861,0.6548 -0.489,0 -0.888,-0.1103 -1.194,-0.3331 -0.307,-0.2207 -0.46,-0.5924 -0.46,-1.1139 0,-0.5965 0.215,-1.0786 0.643,-1.4471 0.428,-0.3664 1.194,-0.5663 2.298,-0.5965 z m -1.149,-9.9481 c 0,0.507 0.153,0.8828 0.46,1.1274 0.306,0.2447 0.682,0.3665 1.126,0.3665 0.428,0 0.8,-0.1218 1.114,-0.3665 0.314,-0.2446 0.471,-0.6204 0.471,-1.1274 0,-0.5351 -0.157,-0.9213 -0.471,-1.1587 -0.314,-0.2384 -0.686,-0.3571 -1.114,-0.3571 -0.444,0 -0.82,0.1187 -1.126,0.3571 -0.307,0.2374 -0.46,0.6236 -0.46,1.1587 m 13.349,13.2575 c -0.444,0 -0.803,-0.1197 -1.08,-0.3571 -0.275,-0.2373 -0.414,-0.5923 -0.414,-1.067 v -6.0433 h 3.515 v -2.5724 h -3.515 v -2.6661 h -2.182 l -0.989,2.6422 -1.882,1.1493 v 1.447 h 1.631 v 6.0433 c 0,1.0712 0.171,1.9103 0.517,2.5141 0.345,0.6059 0.812,1.0306 1.4,1.2753 0.589,0.2446 1.261,0.3685 2.01,0.3685 0.644,0 1.238,-0.0583 1.782,-0.1728 0.542,-0.1156 0.998,-0.2478 1.367,-0.4019 v -2.5495 c -0.353,0.1062 -0.705,0.1978 -1.056,0.2749 -0.354,0.076 -0.723,0.1155 -1.104,0.1155 m -113.7,25.477 4.228,-12.8419 h 0.091 c -0.014,0.3061 -0.033,0.7631 -0.058,1.3669 -0.022,0.6059 -0.045,1.2451 -0.069,1.9176 -0.023,0.6756 -0.033,1.2711 -0.033,1.7937 v 7.7637 h 3.24 V 85.5797 h -4.734 l -4.112,12.5445 h -0.069 l -3.883,-12.5445 h -4.732 v 16.4033 h 3.102 v -7.6273 c 0,-0.5674 -0.016,-1.1993 -0.047,-1.8947 -0.03,-0.6965 -0.061,-1.3513 -0.091,-1.9644 -0.031,-0.6132 -0.055,-1.0713 -0.07,-1.3784 h 0.091 l 3.953,12.8648 z m 16.406,-12.7957 c -0.888,0 -1.743,0.1 -2.562,0.2978 -0.818,0.1999 -1.567,0.4747 -2.239,0.8276 l 1.125,2.3205 c 0.581,-0.2592 1.163,-0.4789 1.746,-0.6538 0.582,-0.178 1.179,-0.2655 1.791,-0.2655 0.614,0 1.092,0.1531 1.436,0.4591 0.346,0.3071 0.517,0.7892 0.517,1.4471 v 0.5517 l -2.183,0.0698 c -1.867,0.0614 -3.27,0.4091 -4.202,1.0452 -0.935,0.635 -1.403,1.6188 -1.403,2.9513 0,1.3482 0.368,2.3489 1.103,2.9989 0.735,0.651 1.662,0.977 2.78,0.977 1.041,0 1.861,-0.154 2.458,-0.46 0.597,-0.307 1.164,-0.797 1.7,-1.47 h 0.092 l 0.665,1.7 h 2.389 v -8.3639 c 0,-1.5012 -0.446,-2.6151 -1.342,-3.3428 -0.897,-0.7266 -2.187,-1.09 -3.871,-1.09 m 1.814,6.9833 v 1.0338 c 0,0.7964 -0.252,1.4137 -0.759,1.8489 -0.504,0.4382 -1.125,0.6548 -1.86,0.6548 -0.489,0 -0.888,-0.1104 -1.194,-0.3331 -0.307,-0.2207 -0.46,-0.5924 -0.46,-1.114 0,-0.5965 0.215,-1.0785 0.643,-1.447 0.428,-0.3664 1.194,-0.5663 2.298,-0.5965 z m 13.922,-6.9605 c -0.841,0 -1.585,0.2301 -2.23,0.6902 -0.642,0.4581 -1.146,1.0088 -1.514,1.6522 h -0.162 l -0.505,-2.1123 H 164.4 v 12.5438 h 3.423 v -6.3871 c 0,-0.7964 0.164,-1.4252 0.495,-1.8843 0.329,-0.458 0.761,-0.7932 1.298,-0.9983 0.535,-0.2082 1.094,-0.3113 1.677,-0.3113 0.154,0 0.333,0.0115 0.54,0.0344 0.206,0.0239 0.363,0.0499 0.472,0.0801 l 0.252,-3.2157 c -0.138,-0.0302 -0.321,-0.0542 -0.551,-0.0688 -0.23,-0.0156 -0.43,-0.0229 -0.599,-0.0229 m 6.846,-4.6871 h -3.423 v 17.46 h 2.619 l 0.574,-1.378 h 0.23 c 0.337,0.413 0.77,0.786 1.3,1.115 0.527,0.329 1.251,0.493 2.171,0.493 1.439,0 2.603,-0.551 3.492,-1.654 0.888,-1.1034 1.331,-2.7263 1.331,-4.8709 0,-2.1279 -0.435,-3.7404 -1.309,-4.8367 -0.873,-1.093 -2.013,-1.6417 -3.422,-1.6417 -0.904,0 -1.64,0.1801 -2.207,0.5403 -0.567,0.3592 -1.019,0.8006 -1.356,1.3201 h -0.136 c 0.03,-0.2593 0.06,-0.6205 0.091,-1.0786 0.031,-0.4601 0.045,-0.9275 0.045,-1.4022 z m 2.459,7.4205 c 0.719,0 1.29,0.3102 1.713,0.9307 0.42,0.6215 0.631,1.5428 0.631,2.7691 0,1.2243 -0.207,2.1633 -0.62,2.814 -0.413,0.6506 -0.974,0.9754 -1.677,0.9754 -0.95,0 -1.604,-0.3248 -1.966,-0.9754 -0.358,-0.6507 -0.54,-1.5814 -0.54,-2.7911 v -0.3685 c 0.032,-1.1326 0.227,-1.9759 0.587,-2.5255 0.359,-0.5518 0.984,-0.8287 1.872,-0.8287 m 16.748,-2.5034 v 5.9048 c 0,1.3304 -0.192,2.3538 -0.574,3.0658 -0.383,0.7121 -1.096,1.0692 -2.137,1.0692 -0.704,0 -1.218,-0.2301 -1.538,-0.6902 -0.322,-0.4591 -0.483,-1.1327 -0.483,-2.0207 v -7.3289 h -3.423 v 8.1774 c 0,1.6084 0.406,2.7765 1.217,3.5045 0.811,0.727 1.891,1.092 3.238,1.092 0.781,0 1.52,-0.146 2.218,-0.439 0.696,-0.289 1.245,-0.756 1.643,-1.4 h 0.183 l 0.46,1.609 h 2.619 V 89.4401 Z m 14.013,-0.23 c -0.841,0 -1.586,0.2301 -2.229,0.6902 -0.644,0.4581 -1.147,1.0088 -1.516,1.6522 h -0.161 l -0.505,-2.1123 h -2.597 v 12.5438 h 3.423 v -6.3871 c 0,-0.7964 0.165,-1.4252 0.496,-1.8843 0.329,-0.458 0.761,-0.7932 1.298,-0.9983 0.534,-0.2082 1.093,-0.3113 1.676,-0.3113 0.154,0 0.333,0.0115 0.54,0.0344 0.207,0.0239 0.364,0.0499 0.472,0.0801 l 0.252,-3.2157 c -0.137,-0.0302 -0.321,-0.0542 -0.551,-0.0688 -0.23,-0.0156 -0.43,-0.0229 -0.598,-0.0229 m 7.26,-5e-4 c -1.501,0 -2.68,0.5747 -3.538,1.7229 -0.857,1.1493 -1.286,2.7494 -1.286,4.8024 0,2.0362 0.417,3.6259 1.253,4.7661 0.834,1.142 1.995,1.712 3.479,1.712 0.752,0 1.424,-0.146 2.023,-0.437 0.597,-0.29 1.109,-0.765 1.539,-1.423 h 0.091 c -0.014,0.213 -0.033,0.458 -0.057,0.735 -0.023,0.275 -0.034,0.544 -0.034,0.804 v 0.253 c 0,1.898 -0.881,2.849 -2.641,2.849 -1.717,0 -3.347,-0.322 -4.895,-0.965 v 2.734 c 0.719,0.275 1.459,0.467 2.217,0.573 0.759,0.107 1.581,0.161 2.469,0.161 2.068,0 3.631,-0.468 4.688,-1.4 1.056,-0.935 1.586,-2.298 1.586,-4.091 V 89.4397 h -2.895 l -0.276,1.6084 h -0.092 c -0.873,-1.2243 -2.083,-1.8385 -3.631,-1.8385 m 1.08,2.7806 c 0.919,0 1.586,0.2894 1.999,0.8735 0.414,0.5809 0.621,1.5459 0.621,2.8941 v 0.4133 c 0,1.2409 -0.212,2.1101 -0.632,2.6078 -0.423,0.4976 -1.069,0.7464 -1.941,0.7464 -1.639,0 -2.459,-1.2472 -2.459,-3.7457 0,-2.5255 0.805,-3.7894 2.412,-3.7894" fill="#000000" fill-rule="nonzero" fill-opacity="1" transform="matrix(1,0,0,1.0024,450,392.174)" id="path1" /><path d="m 108.447,98.0477 v -0.0013 c 0.356,-0.6912 0.773,-1.4917 0.806,-1.5722 0,0 -6.608,-7.2949 -16.2708,-12.8605 0,0 -2.4157,-1.4212 -3.0786,-1.9774 -1.1328,-0.9509 -1.3978,-1.9655 -1.3455,-3.7746 0.6039,-0.3356 2.9318,-1.8267 3.8202,-3.7565 4.6302,0.5328 10.7637,-0.7938 11.0007,-6.9754 1.25,-1.5548 1.812,-3.5571 1.587,-5.3522 -0.642,-5.1193 -3.568,-7.4525 -7.8629,-10.2628 -5.2422,-5.3683 -14.4629,-7.4841 -22.9574,-5.8736 -3.8954,0.0517 -7.0198,0.4724 -9.6549,1.3341 -3.8148,1.2473 -6.6191,3.3604 -9.3784,6.1339 -1.1368,0.6871 -6.8057,4.1752 -7.2398,9.9628 -0.3214,4.288 1.6501,7.3263 4.7449,7.7055 2.1077,2.8184 3.9263,3.5833 6.8131,3.5364 1.0427,-0.0168 1.8808,-0.1416 2.519,-0.2779 -0.1557,0.7926 -0.0779,1.4918 0.2321,2.0582 0.604,1.1071 1.467,1.1924 1.8434,1.2119 0.3764,0.0187 1.1052,-0.1424 1.1052,-0.1424 0,2.0528 0.7341,3.1224 1.279,3.7659 -0.1886,0.881 -0.2489,2.1815 0.726,3.3787 1.3898,1.7051 4.5872,0.6804 5.6073,0.3751 v 0.0027 l -0.0276,1.756 c -1.8896,0.235 -4.0483,0.7388 -6.1795,1.5454 -9.2865,3.5137 -19.4876,11.1983 -19.4876,11.1983 0,0 0.6952,0.9832 0.9233,1.3022 l -2.8539,2.099 c 1.887,3.557 5.5683,6.748 5.5683,6.748 0,0 1.0777,-1.29 1.2743,-1.53 1.1561,1.014 3.8182,3.238 6.511,4.704 -0.2227,0.501 -0.6999,1.452 -0.8247,1.657 l 1.5655,0.879 c 1.265,-2.407 2.0977,-4.107 2.8157,-5.806 0.5603,1.156 1.2454,2.012 1.791,2.575 -0.8958,0.441 -1.6145,1.398 -1.8856,2.328 -0.4228,1.448 0.3013,2.687 1.5682,3.101 1.0281,0.336 2.4573,0.114 3.1767,-1.421 0.4221,-0.901 0.308,-1.935 0.0107,-3.016 0.8428,-0.102 1.9702,-0.384 3.2365,-1.081 l -0.0014,0.004 c -0.0806,0.262 -1.2367,4.312 -1.7179,7.08 l 1.832,0.362 c 0.108,-0.53 0.2415,-1.158 0.3972,-1.847 1.848,0.394 6.4902,1.081 9.9575,0.826 -0.0496,0.356 -0.2919,2.221 -0.2919,2.221 23.5636,-2.18 31.4036,-19.497 31.4036,-19.497 z m -1.455,-1.3367 c -2.689,5.707 -8.5622,11.178 -16.9441,14.897 -1.3019,-2.986 -5.583,-11.582 -10.0918,-11.6223 -1.8191,-0.0134 -3.4638,1.2903 -4.4402,2.4213 l -0.1067,-0.036 c 1.3394,-3.0892 3.59,-5.556 5.6836,-6.3947 6.8782,-2.7581 9.3174,-8.5255 10.3575,-11.3976 3.1874,1.9863 10.6427,6.7573 15.5417,12.1323 m -26.3373,19.752 c -4.2853,0.19 -8.2753,-0.613 -9.7803,-0.979 0.2174,-0.861 0.818,-3.476 1.0998,-4.419 1.0247,-3.42 4.2242,-9.102 8.1967,-8.927 0.8455,0.033 1.7776,0.579 2.6969,1.471 l 0.0013,0.001 c -0.3765,1.987 -1.4743,7.958 -2.2144,12.853 m 7.2828,-40.2387 c -2.2259,-0.7106 -3.421,-2.5929 -3.884,-3.4182 0.9059,-1.6441 1.1816,-3.1875 0.8529,-4.3618 -0.2684,-0.9663 -0.7852,-1.5937 -1.8319,-2.0567 -1.6414,-0.7314 -3.0593,-0.0093 -3.9826,1.0683 l -0.1007,-0.0295 c 0.1363,-1.6461 -0.6107,-5.3045 -3.3908,-6.5956 -1.3615,-0.6308 -3.9678,-0.9616 -6.1755,-1.2635 0.6576,-1.2952 1.4521,-2.0985 1.895,-2.4004 12.0921,-1.805 19.5802,4.8946 20.6203,6.5051 2.2278,7.4819 -2.6204,11.9685 -4.0027,12.5523 M 54.752,70.5292 c 1.5172,-0.4522 3.4485,-1.5038 5.973,-3.494 l -0.7892,-1.0106 c -3.0471,2.2896 -6.4601,3.8605 -8.2893,2.6372 -1.2817,-0.8576 -2.0366,-2.858 -1.8789,-5.1952 0.1993,-2.9532 2.0842,-6.301 5.6522,-8.5738 1.2923,1.2695 3.2739,2.4117 5.9078,3.4001 l 0.6294,-1.2045 c -2.7143,-1.0194 -4.1148,-2.3695 -4.9503,-3.3397 2.4171,-2.2816 5.1154,-4.094 8.2819,-5.1374 2.4198,-0.7973 5.1073,-1.1402 7.9753,-1.2683 -0.0516,1.1374 0.0826,2.3298 1.3844,4.6529 l 1.3287,-0.261 c -0.9986,-2.3815 -0.8436,-3.5927 -0.71,-4.5705 4.31,-0.5334 8.1021,-0.2482 11.2734,0.5926 3.8383,1.0173 6.7774,2.8217 8.7456,4.6315 -0.4006,0.8495 -1.3247,2.2439 -3.4405,3.5631 l 0.9831,0.7918 c 2.3816,-0.9642 3.5424,-2.2237 4.1101,-3.1659 1.9373,1.2213 5.8853,4.2142 6.1013,8.5155 0.072,1.4441 -0.229,2.9103 -1.263,3.9946 -0.828,0.8683 -2.6058,1.9494 -4.6564,1.5475 L 96.879,68.863 c 0.5368,0.1075 2.6398,0.4771 4.268,-0.4495 l 0.08,0.0604 v 0.0066 l 0.02,-0.0066 0.004,-0.0014 c -0.745,3.4021 -5.0276,4.2872 -8.0553,4.1047 2.1111,-4.8301 0.1859,-9.7642 0.167,-9.8072 0,0 -2.6942,-4.5012 -10.5151,-6.5493 -8.6698,-2.2707 -15.6251,0.141 -17.5006,0.8724 l 0.4027,1.0871 c 1.0152,-0.2886 2.9022,-0.661 2.9022,-0.661 l 0.0214,0.0396 c -1.4467,1.791 -2.7814,4.763 -3.1169,5.7226 -0.4429,1.2749 -0.2899,2.9384 -0.1892,3.596 -0.4576,0.9791 -1.4683,2.9211 -2.7016,5.2818 -1.2724,0.3422 -5.4334,1.4662 -7.9136,-1.63 m 15.1507,12.99 c -0.8972,0.1053 -1.9513,-0.4469 -1.9252,-1.9468 0.0067,-0.3623 0.09,-1.2628 0.09,-1.2628 0,0 -0.4121,-0.4744 -0.6537,-0.7911 0.7972,-0.0518 2.1929,-0.2625 3.7317,-0.865 l -0.2241,-1.1274 c -1.4489,0.2752 -2.7077,0.3396 -4.2249,0.0209 0.1772,-2.0125 -0.4368,-2.3963 -0.4368,-2.3963 0,0 -1.7642,0.3771 -1.9978,0.3241 -0.2341,-0.0538 -0.3435,-0.157 -0.4106,-0.2846 -0.1208,-0.2282 -0.0946,-0.8247 0.3617,-1.7306 1.5165,-3.0062 3.0666,-6.3882 3.0666,-6.3882 0,0 -0.4127,-1.6783 0.0296,-3.0358 0.2281,-0.6999 0.8146,-1.8493 1.2159,-2.7318 0.0288,0.0041 3.8678,0.192 6.3943,1.2629 2.1735,0.9221 2.6841,4.1846 2.5868,6.2024 l 1.8789,0.5167 c 0,0 1.4857,-1.8729 2.872,-1.3219 1.9615,0.7791 0.4684,3.7738 -0.0839,4.657 -0.3375,0.5402 -0.9945,1.1327 -1.6607,1.1743 -0.1967,0.012 -0.6711,0.0603 -1.114,-0.3557 l -0.5368,0.8857 c 0.4027,0.5906 0.9199,0.949 1.5682,1.0308 1.0656,0.1342 2.05,-0.5965 2.4849,-1.0092 1.1783,1.8775 3.1699,3.0794 3.8624,3.2753 -0.0537,1.9728 0.4972,4.6301 2.9223,5.9702 -3.6644,4.0665 -10.7841,7.2337 -15.2532,5.7508 L 74.3725,84.062 c 2.1406,-1.067 4.2946,-2.8049 5.7514,-5.4958 l -1.02,-0.6241 c -2.0876,3.8652 -6.6788,5.2811 -9.2012,5.5771 m 2.7787,4.6609 -0.0402,2.3641 c 0,0 1.3487,0.9999 4.0329,0.9395 5.5428,-0.0873 10.0716,-2.8331 12.0572,-4.8979 l 0.0711,0.0597 c 0,0 -3.0673,5.7783 -8.4644,7.7236 -2.6465,0.9535 -4.6704,3.5431 -6.3078,6.5959 v 10e-4 c -1.3904,-0.087 -4.8099,-0.427 -8.7154,-1.7406 1.3313,-4.504 3.1311,-8.2933 7.3666,-11.0453 m -3.1874,0.4651 0.0329,0.053 c -3.8886,3.0922 -5.7112,9.3388 -6.3185,11.7528 l -0.0725,-0.006 c -0.2603,-0.6989 -0.6938,-1.2592 -1.3131,-1.4518 -0.7422,-0.2315 -2.6923,-0.8697 -8.692,4.8148 -1.434,-1.433 -2.7949,-3.308 -3.5055,-4.2787 3.0473,-2.4633 13.563,-9.1106 19.8687,-10.8841 M 50.4346,106.788 c -1.2736,-1.307 -2.3923,-2.724 -3.0075,-3.718 l 1.5628,-1.232 c 0.7367,0.934 1.9024,2.32 2.9016,3.316 -0.3859,0.41 -1.0462,1.172 -1.4569,1.634 m 8.7933,4.155 c -2.5043,-1.373 -4.9617,-3.644 -5.9857,-4.642 2.8459,-3.196 5.4998,-5.237 6.7413,-5.43 0.6864,-0.106 1.3735,-0.031 1.6775,0.861 0.3174,0.932 0.0376,2.571 -0.5475,4.438 l -0.0087,0.001 0.0027,0.018 c -0.4771,1.519 -1.1542,3.188 -1.8796,4.754 m 5.597,-9.9 c 3.472,1.153 6.5447,1.582 8.3068,1.74 l -6e-4,0.001 c -0.8583,1.851 -1.583,3.83 -2.2132,5.741 -2.4492,2.271 -4.6294,2.76 -5.2783,2.728 -0.5409,-0.455 -1.9903,-2.319 -2.4627,-4.94 0.6885,-1.905 1.2153,-3.659 1.648,-5.27 m 17.4523,17.291 c 0.5946,-4.208 1.6052,-9.858 2.1614,-12.885 2.2467,2.603 4.5356,8.541 4.5356,8.541 0,0 11.8408,-3.612 18.4738,-14.1989 l 0.002,-0.0027 1.826,1.4926 c -9.038,13.63 -22.7833,16.595 -26.9988,17.053 M 68.2821,66.3556 c 0.088,-0.0416 3.4243,-1.3333 6.195,1.0112 l -0.4582,0.9704 c 0,0 -1.6985,-0.6972 -2.2736,-0.6261 l -0.0268,0.1114 c 0.367,0.4637 0.1731,1.1193 -0.1932,1.3917 l -1.267,0.1598 -0.4093,-1.1369 -0.1309,-0.3603 c -0.3597,0.1161 -0.5663,0.2456 -0.6045,0.2752 l -0.8315,-1.7964" fill="#000000" fill-rule="nonzero" fill-opacity="1" transform="matrix(1,0,0,1.0024,450,392.174)"/></g></svg>';
const BALLOT_BOX_FILLED = '<svg fill="#000000" width="800px" height="800px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><namedview pagecolor="#ffffff" bordercolor="#000000" borderopacity="0.25" /><rect style="fill:#ffffff;fill-rule:evenodd;stroke-width:0.04" width="26.983051" height="26.983051" x="2.5084743" y="2.5084743" /> <path d="m 0,26.016 c 0,1.664 0.58666667,3.072 1.76,4.224 1.1733333,1.152 2.592,1.738667 4.256,1.76 h 20 c 1.642667,0 3.050667,-0.586667 4.224,-1.76 C 31.413333,29.066667 32,27.658667 32,26.016 v -20 C 32,4.352 31.413333,2.9333333 30.24,1.76 29.066667,0.58666667 27.658667,0 26.016,0 h -20 C 4.352,0 2.9333333,0.58666667 1.76,1.76 0.58666667,2.9333333 0,4.352 0,6.016 Z m 4,0 v -20 C 4,5.4613333 4.192,4.992 4.576,4.608 4.96,4.224 5.44,4.0213333 6.016,4 h 20 c 0.533333,0 1.002667,0.2026667 1.408,0.608 0.405333,0.4053333 0.597333,0.8746667 0.576,1.408 v 20 c 0,0.554667 -0.192,1.024 -0.576,1.408 C 27.04,27.808 26.570667,28 26.016,28 h -20 C 5.4613333,28 4.9813333,27.808 4.576,27.424 4.1706667,27.04 3.9786667,26.570667 4,26.016 Z"/> <path d="m 5.2979544,23.287903 c 0,0.951293 0.3292937,1.756233 0.9878811,2.414821 0.6585874,0.658587 1.4818217,1.006175 2.4697028,1.042763 0.9878812,0.03658 1.7928207,-0.310999 2.4148207,-1.042763 L 16,20.873082 l 4.829641,4.829642 c 0.658588,0.695175 1.463527,1.042763 2.414821,1.042763 0.951293,0 1.774527,-0.347588 2.469703,-1.042763 0.695175,-0.695176 1.024468,-1.500117 0.987881,-2.414821 -0.03658,-0.914704 -0.365882,-1.719646 -0.987881,-2.414821 l -4.884524,-4.884523 4.884524,-4.829641 c 0.658587,-0.658588 0.987881,-1.4635271 0.987881,-2.4148207 0,-0.9512935 -0.329294,-1.7562331 -0.987881,-2.4148205 C 25.055577,5.6706894 24.232343,5.3231015 23.244462,5.2865134 22.256581,5.2499252 21.451641,5.5975129 20.829641,6.3292768 L 16,11.158918 11.170359,6.3292768 C 10.511771,5.6341012 9.7068319,5.2865134 8.7555383,5.2865134 c -0.9512935,0 -1.7745278,0.3475878 -2.4697028,1.0427634 -0.6951756,0.695175 -1.0244693,1.5001164 -0.9878811,2.4148205 0.036588,0.9147042 0.3658818,1.7196457 0.9878811,2.4148207 l 4.8845235,4.829641 -4.8845235,4.884523 C 5.6272481,21.53167 5.2979544,22.336609 5.2979544,23.287903 Z" style="stroke-width:1.71507"/></svg>';
const BALLOT_BOX_EMPTY = '<svg fill="#000000" width="800px" height="800px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><namedview id="namedview1" pagecolor="#ffffff" bordercolor="#000000" borderopacity="0.25" /><rect style="fill:#ffffff;fill-rule:evenodd;stroke-width:0.04" width="26.983051" height="26.983051" x="2.5084743" y="2.5084743" /> <path d="m 0,26.016 c 0,1.664 0.58666667,3.072 1.76,4.224 1.1733333,1.152 2.592,1.738667 4.256,1.76 h 20 c 1.642667,0 3.050667,-0.586667 4.224,-1.76 C 31.413333,29.066667 32,27.658667 32,26.016 v -20 C 32,4.352 31.413333,2.9333333 30.24,1.76 29.066667,0.58666667 27.658667,0 26.016,0 h -20 C 4.352,0 2.9333333,0.58666667 1.76,1.76 0.58666667,2.9333333 0,4.352 0,6.016 Z m 4,0 v -20 C 4,5.4613333 4.192,4.992 4.576,4.608 4.96,4.224 5.44,4.0213333 6.016,4 h 20 c 0.533333,0 1.002667,0.2026667 1.408,0.608 0.405333,0.4053333 0.597333,0.8746667 0.576,1.408 v 20 c 0,0.554667 -0.192,1.024 -0.576,1.408 C 27.04,27.808 26.570667,28 26.016,28 h -20 C 5.4613333,28 4.9813333,27.808 4.576,27.424 4.1706667,27.04 3.9786667,26.570667 4,26.016 Z"/></svg>';
const RADIO_BUTTON_FILLED= '<svg fill="#000000" width="800px" height="800px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><namedview pagecolor="#ffffff" bordercolor="#000000" borderopacity="0.25"/> <title id="title1">cross-checkbox</title><ellipse style="fill:#000000;stroke:none;stroke-width:0.123126;stroke-dasharray:none;paint-order:stroke fill markers" id="path3-0" cx="16" cy="16" rx="15.756952" ry="15.792681"/> <ellipse style="fill:#ffffff;stroke:none;stroke-width:0.0931914;stroke-dasharray:none;paint-order:stroke fill markers" cx="16" cy="16" rx="11.926133" ry="11.953176" /> <ellipse style="fill:#000000;stroke:none;stroke-width:0.068284;stroke-dasharray:none;paint-order:stroke fill markers" cx="16" cy="16" rx="8.7386189" ry="8.7584343"/></svg>';
const RADIO_BUTTON_EMPTY = '<svg fill="#000000" width="800px" height="800px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><namedview id="namedview1" pagecolor="#ffffff" bordercolor="#000000" borderopacity="0.25"/><ellipse style="fill:#000000;stroke:none;stroke-width:0.123126;stroke-dasharray:none;paint-order:stroke fill markers" id="path3-0" cx="16" cy="16" rx="15.756952" ry="15.792681"/><ellipse style="fill:#ffffff;stroke:none;stroke-width:0.0931914;stroke-dasharray:none;paint-order:stroke fill markers" id="path3" cx="16" cy="16" rx="11.926133" ry="11.953176" /> </svg>';

const FORM_SECTION_BACKGROUND = '#ddd';
const TEXT_SECTION_BACKGROUND = '#fff';
const HEADING_FONT_SIZE = 11;
const DEFAULT_FONT_SIZE = 9;

const SEPARATOR = '\n';
const EMPTY_CELL = '';

type FormFieldOption = {
	key: string,
	label: string
};

type FormFieldDefinition = {
	checked?: boolean | undefined,
	optional?: boolean | undefined,
	title?: Content | undefined,
	value?: Content | undefined
	background?: string,
	box?: string
	options?: FormFieldOption[]
}

export function download(dd: TDocumentDefinitions, filename: string) {
	pdfMake.createPdf(dd).download(filename);
}

export function print(dd: TDocumentDefinitions) {
	pdfMake.createPdf(dd).print();
}

export type SimpleTranslateFunction = (key: string, substitution?: {[k:string] : string}) => Content;

function fillInOrPassThrough(t: SimpleTranslateFunction, key: string, substitutions: { [k: string]: Content }): Content {
	const variables = Object.keys(substitutions);

	const identitySubstitution: {[k:string] : string} = {};
	variables.forEach((key) => {identitySubstitution[key] = "{" + key + "}";});
	const translation = t(key, identitySubstitution);
	if (translation && typeof translation === "string") {
		return fillIn(translation, substitutions);
	} else {
		return translation;
	}
}

export function pdfFormDocumentDefinition(formData: Form.AnmeldungDerAbschlussarbeit, isFinal: boolean, t_regular: TFnType, lang: string): TDocumentDefinitions {

	const t = (key: string, substitution?: {[k:string] : string}) => {
		const result = t_regular(key, {...substitution, noWrap: true});
		if (result === key) {
			return { text: key, color: "red"};
		}
		return result;
	};

	const schema = schemaJson as JsonSchema7;

	const subject = Data.getSubject(formData);
	const degree = Data.getDegree(formData);
	const exam_regulations = Data.getExamRegulations(formData);

	const requirementsRows = [];
	const requirementsPropertyName = Data.getRequirementsPropertyName(formData);

	let requirementsFulfilled = true;

	if (requirementsPropertyName === undefined ||  formData[requirementsPropertyName as Data.FormKey] === undefined) {
		// studies not fully specified
		const requirementOther = formData.requirements_other;
		if (requirementOther !== undefined) {
			requirementsRows.push([{ checked: requirementOther.fulfilled, value: requirementOther.description }]);
			requirementsFulfilled = requirementOther.fulfilled === true;
		} else {
			requirementsRows.push([{ checked: undefined, value: undefined }]);
			requirementsFulfilled = false;
		}

	} else {

		const requirements = formData[requirementsPropertyName as Data.FormKey] as Form.Requirements;

		if (schema.properties !== undefined && schema.properties[requirementsPropertyName]) {
			const requirementPropertiesMO = schema.properties[requirementsPropertyName].properties;

			let requirementsRow = [];

			for (const key in requirementPropertiesMO) {
				const checked = requirements[key] ?? false; // treat undefined as false
				const desc = t(requirementsPropertyName + '.' + key + '.description');
				requirementsRow.push({ checked: checked, value: desc });

				if (requirementsRow.length === 2) {
					requirementsRows.push(requirementsRow);
					requirementsRow = [];
				}

				if (schema.properties[requirementsPropertyName].required?.includes(key)) {
					requirementsFulfilled &&= checked;
				}
			}

			if (requirementsRow.length > 0) {
				requirementsRows.push(requirementsRow);
			}
		} else {
			throw new Error('Illegal Schema.');
		}
	}

	const supervisor = Data.getSupervisorName(formData);
	const second_supervisor = Data.getSecondSupervisorName(formData);

	const iconv = require('iconv-lite');
	const csvEncoded = iconv.encode(Data.csvData(formData, subject, degree, exam_regulations, lang, requirementsFulfilled), 'iso-8859-1');

	return {
		pageSize: 'A4',
		pageOrientation: 'portrait',
		pageMargins: [20, 20, 20, 20],
		footer: { text: FORM_NAME + ' v' + FORM_VERSION + ' (' + FORM_DATE + ')', fontSize: 7, alignment: 'center' },
		content: [
			header(isFinal, t, degree, subject, exam_regulations),
			SEPARATOR,
			section(isFinal, t, FORM_SECTION_BACKGROUND, TEXT_SECTION_BACKGROUND, t('form.contact_data'), ['*'],
				[
					columnsDefaultPadding(isFinal, t, FORM_SECTION_BACKGROUND, TEXT_SECTION_BACKGROUND, undefined,
						[{ title: t('firstname.label'), value: formData.firstname }, { title: t('lastname.label'), value: formData.lastname }],
						[{ title: t('email.label'), value: formData.email, optional: true }, { title: t('phone.label'), value: formData.phone, optional: true }],
						[{ title: t('home_address.label'), value: formData.home_address, optional: true }]
					)
				], [
				columnsWithPadding(isFinal, t, FORM_SECTION_BACKGROUND, FORM_SECTION_BACKGROUND, 0, ['auto', '*', 'auto', 'auto'],
					[{ checked: formData.agreement_alumni, value: t('agreement_alumni.description') }, { title: t('pdf.language'), value: lang, options: [{ key: 'de', label: 'Deutsch' }, { key: 'en', label: 'English' }] }]
				)
			]),
			section(isFinal, t, FORM_SECTION_BACKGROUND, TEXT_SECTION_BACKGROUND, t('form.personal_data'), ['*'],
				[
					columnsDefaultPadding(isFinal, t, FORM_SECTION_BACKGROUND, TEXT_SECTION_BACKGROUND, undefined,
						[{ title: t('studentid.label'), value: formData.studentid }, { title: t('username.label'), value: formData.username }],
						[{ title: t('birthday.label'), value: formData.birthday }, { title: t('birthplace.label'), value: formData.birthplace }],
					)
				]),
			section(isFinal, t, TEXT_SECTION_BACKGROUND, FORM_SECTION_BACKGROUND, undefined, ['*'], [{
				text:
					fillInOrPassThrough(t, 'pdf.application',
						{
							degree: textMandatoryOrField(isFinal, t, degree),
							subject: textMandatoryOrField(isFinal, t, subject),
							exam_regulations: textMandatoryOrField(isFinal, t, exam_regulations)
						})
			}],
				[
					signature(isFinal, t, t('pdf.applicant'), TEXT_SECTION_BACKGROUND, FORM_SECTION_BACKGROUND),
				]),
			section(isFinal, t, FORM_SECTION_BACKGROUND, TEXT_SECTION_BACKGROUND, t('form.final_thesis'), ['*'],
				[
					columnsDefaultPadding(isFinal, t, FORM_SECTION_BACKGROUND, TEXT_SECTION_BACKGROUND, undefined,
						[{ title: t('supervisor.label'), value: supervisor }, { title: t('second_supervisor.label'), value: second_supervisor }],
						[{ title: t('title.label'), value: formData.title }],
						[{ title: t('start_date.label'), value: formData.start_date }, { checked: formData.external, value: t('external.label'), box: FORM_SECTION_BACKGROUND }]
					)
				]),
			section(isFinal, t, FORM_SECTION_BACKGROUND, TEXT_SECTION_BACKGROUND,
				t('pdf.admission_requirements'),
				['*'],
				[
					columnsWithPadding(isFinal, t, FORM_SECTION_BACKGROUND, FORM_SECTION_BACKGROUND, 0, undefined,
						...requirementsRows
					)
				]
			),
			section(isFinal, t, FORM_SECTION_BACKGROUND, TEXT_SECTION_BACKGROUND, t('form.comment'), ['*'],
				[
					columnsDefaultPadding(isFinal, t, FORM_SECTION_BACKGROUND, TEXT_SECTION_BACKGROUND, undefined,
						[{ title: t('comment.label'), value: formData.comment,optional: true }]
					)
				]),
			section(isFinal, t, TEXT_SECTION_BACKGROUND, FORM_SECTION_BACKGROUND, undefined, ['*', 'auto'],
				[{
					text: fillInOrPassThrough(t, 'pdf.supervisor_agreement', { degree: textMandatoryOrField(isFinal, t, degree) }),
					colSpan: 2
				},
					EMPTY_CELL
				],
				[signature(isFinal, t, t('supervisor.label'), TEXT_SECTION_BACKGROUND, FORM_SECTION_BACKGROUND),
				{
					rowSpan: 5,
					stack: [{
						text: (isFinal
							? fillInOrPassThrough(
								t,
								'pdf.qr_final',
								{
									here: {
										text: (t('pdf.here') ?? { text: 'error', color: 'red' }),
										link: Data.editLink(formData, lang),
										decoration: 'underline',
										color: 'blue'
									}
								})
							: fillInOrPassThrough(
								t,
								'pdf.qr_draft',
								{
									here: {
										text: (t('pdf.here') ?? { text: 'error', color: 'red' }),
										link: Data.editLink(formData, lang),
										decoration: 'underline',
										color: 'blue'
									}
								})),

						alignment: 'center'
					},
					{ text: '\n' },
					{
						qr: (isFinal ? csvEncoded : Data.editLink(formData, lang)),
						fit: 140,
						alignment: 'center',
						mode: 'octet'
					}]
				}],
				[
					fillInOrPassThrough(t, 'pdf.agreement_second_supervisor', { degree: textMandatoryOrField(isFinal, t, degree) }),
					EMPTY_CELL],
				[signature(isFinal, t, t('second_supervisor.label'), TEXT_SECTION_BACKGROUND, FORM_SECTION_BACKGROUND), EMPTY_CELL],
				[{
					text: fillInOrPassThrough(t, 'pdf.agreement_exam_committee',
						{ degree: textMandatoryOrField(isFinal, t, degree) })
				}, EMPTY_CELL],
				[signature(isFinal, t, t('pdf.chair_exam_committee'), TEXT_SECTION_BACKGROUND, FORM_SECTION_BACKGROUND),
					EMPTY_CELL
				])
		],
		defaultStyle: {
			fontSize: DEFAULT_FONT_SIZE
		}
	};
}

function textMandatory(isFinal: boolean, t: SimpleTranslateFunction, value: Content | undefined) {
	if (value === undefined) {
		if (isFinal)
			return '';
		else
			return { text: t('pdf.missing'), color: 'red' };
	} else {
		return value;
	}
}

function textOptional(_isFinal: boolean, _t: SimpleTranslateFunction, value: Content | undefined) {
	if (value === undefined) {
		return '';
	} else {
		return value;
	}
}
function textMandatoryOrField(isFinal: boolean, t: SimpleTranslateFunction, value: string | undefined): Content {
	if (value === undefined) {
		if (isFinal)
			return { text: '[                      ]' };
		else
			return { text: t('pdf.missing') ?? { text: 'translation error', color: 'red' }, color: 'red' };
	} else {
		return value;
	}
}

function header(isFinal: boolean, t: SimpleTranslateFunction, degree: string | undefined, subject: string | undefined, exam_regulations: string | undefined) : Content {
	const result =
	{
		layout: {
			hLineWidth: function(i: number, _node: ContentTable) { return i === 2 ? 1 : 0; },
			vLineWidth: function(_i: number) { return 0; },
			hLineColor: function(_i: number) { return '#333'; },
			paddingLeft: function(_i: number) { return 0; },
			paddingRight: function(_i: number, _node: ContentTable) { return 0; },
			paddingTop: function(_i: number) { return 2; },
			paddingBottom: function(_i: number) { return 2; },
		},
		table: {
			widths: ['*', 'auto'],
			body: [[{
				text: t("address"),
			},
			{
				svg: UNI_MR,
				fit: [300, 35],
				alignment: 'right'
			}],
			[{
				colSpan: 2,
				fontSize: HEADING_FONT_SIZE,
				alignment: 'center',
				text: appendIfFinal(
					isFinal,
					fillInOrPassThrough(t, "pdf.title",
						{
							degree: textMandatoryOrField(isFinal, t, degree),
							subject: textMandatoryOrField(isFinal, t, subject),
							exam_regulations: textMandatoryOrField(isFinal, t, exam_regulations)
						}),
					[' --- ', { text: t('pdf.draft') ?? { text: 'translation error', color: 'red' }, color: 'red' }]
				)
			}]]
		}
	};

	return result as Content;
}

function appendIfFinal(isFinal: boolean, basic: Content, toAppend: Content[]) {
	if (isFinal)
		return basic;

	return (Array.isArray(basic) ? basic : [basic]).concat(toAppend);
}

function columnsDefaultPadding(isFinal: boolean, t: SimpleTranslateFunction, background: string, box: string, widths? : string[], ...rows: FormFieldDefinition[][]) {
	return columnsWithPadding(isFinal, t, background, box, 3, widths, ...rows);
}

function columnsWithPadding(isFinal: boolean, t: SimpleTranslateFunction, background: string, box: string, padding: number, widths? : string[], ...rows: FormFieldDefinition[][]) {
	if (rows.length === 0)
		return '';

	let cols = 0;
	for (let i = 0; i < rows.length; i++) {
		if (rows[i].length > cols) {
			cols = rows[i].length;
		}
	}

	if (widths === undefined) {
		widths = [];
		for (let i = 0; i < cols; i++) {
			widths.push('auto', '*');
		}
	}

	const body: TableCell[][] = [];

	const result = {
		table: {
			widths: widths,
			body: body,
		},
		layout: {
			vLineWidth: function(i: number) { return i === 0 ? 0 : 5; },
			vLineColor: function(_i: number, _node: ContentTable) { return background; },
			hLineWidth: function(_i: number, _node: ContentTable) { return 3; },
			hLineColor: function(_i: number, _node: ContentTable) { return background; },
			fillColor: function(_rowIndex: number, _node: ContentTable, columnIndex: number) { return (columnIndex % 2 === 1) ? box : background; },
			paddingLeft: function(_i: number) { return 2; },
			paddingRight: function(_i: number) { return 2; },
			paddingTop: function(_i: number) { return padding; },
			paddingBottom: function(_i: number) { return padding; },
		}
	};


	for (let i = 0; i < rows.length; i++) {
		const row: TableCell[] = [];
		const rowDef = rows[i];

		// don't allow empty rows
		if (rowDef.length > 0) {

			for (let c = 0; c < rowDef.length; c++) {
				const title = rowDef[c].title ?? '';
				if (rowDef[c].title === undefined) {
					row.push({
						svg: (rowDef[c].checked ? BALLOT_BOX_FILLED : BALLOT_BOX_EMPTY),
						alignment: 'right',
						fit: [10, 10]
					})
				} else {
					row.push({
						text: [title, ":"],
						noWrap: true
					});
				}

				let cell: TableCell;
				const options = rowDef[c].options;
				if (options === undefined) {
					cell = {
						colSpan: 1,
						fillColor: (rowDef[c].box),
						text: ((rowDef[c].optional !== undefined && rowDef[c].optional) ?
							textOptional(isFinal, t, rowDef[c].value) :
							textMandatory(isFinal, t, rowDef[c].value)),
					};

				} else {
					const currentCellDef = rowDef[c];

					cell = {
						table: {
							widths: options.flatMap((_) => ['auto', 'auto']),
							body: [
								options.flatMap(o =>
									[{
										svg: (o.key === currentCellDef.value ? RADIO_BUTTON_FILLED : RADIO_BUTTON_EMPTY),
										alignment: 'right',
										fit: [10, 10]
									},
									o.label]
								)
							]
						},
						layout: {
							vLineWidth: function(_i: number) { return 0; },
							hLineWidth: function(_i: number, _node: ContentTable) { return 0; },
							paddingLeft: function(_i: number) { return 2; },
							paddingRight: function(_i: number) { return 2; },
							paddingTop: function(_i: number) { return 0; },
							paddingBottom: function(_i: number) { return 0; },
						}

					};

				}
				row.push(cell);


				// this is the last defined column for this row
				// if necessary expand col span and fill with empty cells
				if (c + 1 === rowDef.length && rowDef.length < cols) {
					const span = 1 + (cols - rowDef.length) * 2;
					if ('colSpan' in cell)
						cell.colSpan = span;
					else
						throw new Error("The table cell is malformed.");
					for (let padding = 0; padding < (span - 1); padding++) {
						row.push({});
					}
				}
			}
		}
		body.push(row);
	}

	return result;
}

function section(_isFinal: boolean, _t: SimpleTranslateFunction, background: string, _box: string, heading: Content | undefined, widths: string[], ...body: TableCell[][]) {
	const result =
	{
		layout: {
			hLineColor: function(_i: number, _node: ContentTable) { return 'white'; },
			hLineWidth: function(i: number, node: ContentTable) { return i === (node.table.body.length) ? 2 : 0; },
			vLineWidth: function(_i: number) { return 0; },
			fillColor: function(_i: number) { return background; },
			paddingLeft: function(_i: number) { return 5; },
			paddingRight: function(_i: number, _node: ContentTable) { return 5; },
			paddingTop: function(_i: number) { return 2; },
			paddingBottom: function(_i: number) { return 2; },
		},
		table: {
			widths: widths,
			body: body
		}
	};

	if (heading !== undefined) {
		result.table.body.unshift([{
			text: heading,
			fontSize: HEADING_FONT_SIZE
		}]);
	}
	return result;
}


function signature(isFinal: boolean, t: SimpleTranslateFunction, signer: Content | undefined, background: string, box: string) {
	return {
		layout: {
			hLineWidth: function(i: number, _node: ContentTable) { return i === 1 ? 1 : 0; },
			vLineWidth: function(_i: number) { return 0; },
			fillColor: function(_i: number) { return background; },
			paddingLeft: function(_i: number) { return 0; },
			paddingRight: function(_i: number, _node: ContentTable) { return 0; },
			paddingTop: function(_i: number) { return 4; },
			paddingBottom: function(_i: number) { return 2; },
		},
		table: {
			widths: [80, '*'],
			heights: 13,
			body: [[{
				text: '',
				fillColor: box
			},
			{
				text: (isFinal ? '' : t('pdf.signature_only_final')),
				color: (isFinal ? 'black' : 'red'),
				fillColor: box
			}],
			[{ text: t('pdf.date') },
			{ text: [t('pdf.signature'), ' ', textMandatory(isFinal, t, signer)] }
			]]
		}
	};
}